import React, { useEffect, useState } from "react";
import "../styles/Loading.css";

export default function LoadingScreen() {
  const steps = [
    { text: "Collecting your inputs…", icon: "📝" },
    { text: "Generating website structure…", icon: "🏗️" },
    { text: "Designing your homepage…", icon: "🎨" },
    { text: "Adding content & images…", icon: "📸" },
    { text: "Preparing your preview…", icon: "✨" }
  ];

  const [activeStep, setActiveStep] = useState(0);
 
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) =>
        prev < steps.length - 1 ? prev + 1 : prev
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const progress = ((activeStep + 1) / steps.length) * 100;

  return (
    <div className="ai-loading-screen">
      <div className="ai-loading-box">
        <h2 className="ai-title">We're building your AI-powered website</h2>
        <p className="ai-sub">This usually takes 15–20 seconds. Hang tight!</p>
 
        <div className="progress-container">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
 
        <ul className="ai-steps">
          {steps.map((step, index) => (
            <li
              key={index}
              className={`step ${
                index < activeStep ? "step-completed" : 
                index === activeStep ? "step-active" : 
                "step-pending"
              }`}
            >
              <span className="step-icon">
                {index < activeStep ? (
                  <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  <span className="emoji-icon">{step.icon}</span>
                )}
              </span>
              <span className="step-text">{step.text}</span>
              {index === activeStep && <span className="step-loader"></span>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}